<template>
  <div class="table__wrapper" id="employee-orders-table">
    <div class="employee__filtration">
      <div class="row">
        <Pagination class="text-center" :meta="meta" />
      </div>
    </div>
    <table class="dashboard__table">
      <thead>
        <tr>
          <th> {{ I18n.t("table.number") }}</th>
          <th>
            <SortLink
              :name="'employees.auctions_catalogs.date'"
              :attribute="'created_at'"
              @changeQ="setQuery"
            />
          </th>
          <th>
            <SortLink
              :name="'employees.auctions_catalogs.object'"
              :attribute="'artwork_catalog_number'"
              @changeQ="setQuery"
            />
          </th>
          <th>
            <SortLink
              :name="'employees.auctions_catalogs.client'"
              :attribute="'user_lastname'"
              @changeQ="setQuery"
            />
          </th>
          <th> {{ I18n.t("employees.auctions_catalogs.phone")}} </th>
          <th> {{ I18n.t("employees.auctions_catalogs.order") }} </th>
          <th> {{ I18n.t("employees.auctions_catalogs.comments") }} </th>
          <th> {{ I18n.t("employees.auctions_catalogs.note") }} </th>
        </tr>
      </thead>
      <tbody>
        <FinishedAuctionsCatalogOrdersRow
          v-for="(order, index) in orders"
          :order="order"
          :key="index"
          :artwork="order.artwork"
          :artist="order.artwork.artist"
          :user="order.user"
          :index="index"
          :meta="meta"
          class="artwork-row"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
  import dataFormatter from '@/shared/data_formatter';
  import { FIRST_PAGE } from '@/shared/consts';
  import Pagination from '@/shared/components/pagination/index';
  import SortLink from '@/shared/components/sort_link';
  import FinishedAuctionsCatalogOrdersRow from './row';

  export default {
    name: 'FinishedAuctionsCatalogsOrdersList',
    components: {
      FinishedAuctionsCatalogOrdersRow,
      SortLink,
      Pagination,
    },
    data() {
      return {
        meta: null,
        orders: null,
        q: null,
      };
    },
    mounted() {
      this.fetchAuctionsCatalogOrders();
    },
    watch: {
      filterParams() {
        const buildQuery = this.$route.query || {};
        buildQuery.page = FIRST_PAGE;
        this.$router.replace({ query: buildQuery });
        this.fetchAuctionsCatalogOrders();
      },
      currentPage() {
        this.filterParams.page = this.currentPage.page;
        this.fetchAuctionsCatalogOrders();
      },
    },
    computed: {
      auctionsCatalogId() {
        return this.$route.params.id;
      },
      currentPage() {
        return {
          page: this.$route.query.page,
        };
      },
      filterParams() {
        return {
          q: {
            s: this.q,
          },
        };
      },
    },
    methods: {
      setQuery(value) {
        this.q = value;
      },
      fetchAuctionsCatalogOrders() {
        this.$http.get(`employees/finished/auctions_catalogs/${this.auctionsCatalogId}/orders`,
          { params: this.filterParams }).then((response) => {
          const deserializedData = dataFormatter.deserialize(response.body);
          this.meta = response.body.meta;
          this.orders = deserializedData;
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/orders/list.vue?3c8021df